export enum SubscriptionPlanEnum {
  FREE = "free",
  STARTER = "starter",
  PROFESSIONAL = "professional",
  ENTERPRISE = "enterprise",
}

export const SubscriptionPlanValues = Object.values(SubscriptionPlanEnum);
